import type { MigrationStrategies } from "./_types/migration-strategies";

// v0 → v1: switch from random uuid `id` to deterministic `bellstate-${userId}`
// so the same user converges to a single row across devices / offline-first
// inserts. v0 rows had random uuids; drop them locally — next pull from
// api-admin gives the canonical row, and the mapper rewrites it to the new id.
// v1 → v2: `id` maxLength widened to include the "bellstate-" prefix
// (10 + userId 100 = 110). Identity transform.
export const NOTIFICATION_BELL_STATE_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: () => null,
    2: (oldDoc) => oldDoc,
  };
